import { colors } from "@dotnet/telematics-design-system";

import { body3SemiBold } from "shared/styles/typography";

import { ListSectionTitleProps, Ref } from "../../types";

const ListSectionTitle = ({
    ref,
    children
}: ListSectionTitleProps & {
    ref: React.RefObject<Ref>;
}) => {
    const { textPlaceholder } = colors;

    return (
        <div
            ref={ref}
            css={[
                body3SemiBold,
                { color: textPlaceholder, padding: "12px 16px 4px 16px" }
            ]}
        >
            {children}
        </div>
    );
};

export default ListSectionTitle;
